<script lang="ts">
	import type { Zoi } from './types';
	import RouteErrorImage from '$assets/route/route-error.svg';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import SkeletonText from '$lib/components/atoms/skeleton/SkeletonText.svelte';
	import * as m from '$paraglide/messages';
	import { createEventDispatcher } from 'svelte';
	import FilterButton from '../pois/list/FilterButton.svelte';
	import ZoiCard from '../search/itinerary/ZoiCard/ZoiCard.svelte';
	import ArrivalZoiFullWidth from './ArrivalZoiFullWidth.svelte';

	export let hasErrors: boolean;
	export let isLoading: boolean;
	export let zois: Zoi[];
	export let containsEv: boolean;
	let extraClasses = '';
	export { extraClasses as classes };

	const dispatch = createEventDispatcher<{
		selectZoi: { zoi: Zoi; zoiPosition: number };
		openSettings: void;
		arrivalZoiClick: { zoi: Zoi; zoiPosition: number };
		retry: void;
	}>();

</script>

{#if hasErrors}
	<div class="flex flex-col gap-4 items-center justify-center w-full">
		<div class="flex flex-col gap-2 justify-center item-center">
			<img class="w-22 h-22 w-full m-b-2" src={RouteErrorImage} alt="Error" />
			<div class="text-center">{m.zoi_card__error()}</div>
		</div>
		<Button
			icon="autorenew"
			text={m.action__retry()}
			size="sm"
			onclick={() => dispatch('retry')}
		/>
	</div>
{:else if isLoading}
	<div class={extraClasses}>
		<SkeletonText text={m.zoi__title()} />
		<div class="overflow-x-auto flex gap-2 py-4 px-1">
			<!-- eslint-disable-next-line svelte/require-each-key -->
			{#each { length: 3 } as _}
				<ZoiCard isLoading />
			{/each}
		</div>
	</div>
{:else if zois.length > 0}
	<div class={extraClasses} data-testid="zoi-list">
		<div class="flex justify-between items-center">
			<div class="text-md text-coloredneutral font-600">{m.zoi__title()}</div>
			<div class="ml-2 relative order-1 py-0.5">
				<FilterButton classes="px-0" color="primary" variant="ghost" onclick={() => dispatch('openSettings')} />
			</div>
		</div>
		<div class="overflow-x-auto flex gap-2 py-4 pt-0 px-2 mx--2 scrollbar-thin">
			{#if zois.length === 1 && zois[0].isArrivalZoi}
				<ArrivalZoiFullWidth
					images={zois[0].images}
					onclick={() => dispatch('arrivalZoiClick', { zoi: zois[0], zoiPosition: 1 })}
				/>
			{:else}
				<!-- eslint-disable-next-line svelte/require-each-key -->
				{#each zois as zoi, index}
					<ZoiCard
						images={zoi.images ?? undefined}
						category={zoi.isArrivalZoi ? 'ACCOMMODATION' : 'TOURISM'}
						on:selectZoi={() => dispatch('selectZoi', { zoi, zoiPosition: index + 1 })}
						{containsEv}
						dataTestId={`zoi-card-${index}`}
					/>
				{/each}
			{/if}
		</div>
	</div>
{/if}
